/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        //Display Menu items on hover
        /*$('.dropdown').hover(function(){
          if($('.navbar-toggle').is(':hidden')) { // enable the trigger'click' only on desktop display
            $('.dropdown-toggle', this).trigger('click');
          }
        });*/
        $(function(){
          $(".dropdown").hover(
            function() {
              if($('.navbar-toggle').is(':hidden')) {//only on desktop display
                $('.dropdown-menu', this).stop( true, true ).fadeIn("fast");
                $(this).toggleClass('open');
              }
            },
            function() {
              if($('.navbar-toggle').is(':hidden')) {//only on desktop display
                $('.dropdown-menu', this).stop( true, true ).fadeOut("fast");
                $(this).toggleClass('open');
              }
            });
        });

        //Display TagList (galleryPage) on click Mobile device
        $('.tagContainer h5').on('click',function(){$(this).parent('.tagContainer').toggleClass('responsiveHover');});

        //Button Back To top
        $('.smoothScroll').on('click', function() {
          $('html, body').animate( { scrollTop: $($(this).attr('href')).offset().top -150 }, 500 );
	        return false;
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        $('#logos-carousel').owlCarousel({
                 items: 4,
                 autoPlay: true,
                 lazyLoad : true,
                 navigation : false,
                 stopOnHover : true,
                 itemsCustom: false,
                 itemsDesktop: [1199, 4],
                 itemsDesktopSmall: [980, 4],
                 itemsTablet: [768, 3],
                 itemsTabletSmall: false,
                 itemsMobile: [479, 2],

                 //Basic Speeds
                 slideSpeed: 200,
                 paginationSpeed: 800,
                 rewindSpeed: 1000
               });
               $('#home-carousel').owlCarousel({
                 singleItem:true,
                 autoPlay: true,
                 lazyLoad : false,
                 navigation : true,
                 stopOnHover : true,
                 itemsCustom: false,

                 //Basic Speeds
                 slideSpeed: 200,
                 paginationSpeed: 800,
                 rewindSpeed: 1000
               });
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
